var map = {
	"./act": 1531,
	"./act.ts": 1531,
	"./gmat": 1532,
	"./gmat.ts": 1532,
	"./gre": 1533,
	"./gre.ts": 1533,
	"./ielts": 1534,
	"./ielts.ts": 1534,
	"./ielts_general_training": 1535,
	"./ielts_general_training.ts": 1535,
	"./lsat": 1536,
	"./lsat.ts": 1536,
	"./mcat": 1537,
	"./mcat.ts": 1537,
	"./sat": 1538,
	"./sat.ts": 1538,
	"./toefl": 1539,
	"./toefl.ts": 1539
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2544;
module.exports = webpackAsyncContext;